<template>
  <nav aria-label="Tour stops">
    <ul class="lg:flex" :class="{ 'lg:py-16 xxl:py-20': titles }">
      <li
        v-for="(stop, i) in guidedtour.children"
        :key="`${stop.slug}`"
        class="lg:w-full"
      >
        <RouterLink
          :to="{ name: 'guided-panorama', params: { panorama_id: stop.slug } }"
          class="block lg:text-center lg:text-sm xxl:text-base focus:outline-none"
        >
          <span class="guided-stop relative inline-flex items-center lg:block">
            <span
              class="guided-dot block h-2 w-2 lg:h-3 lg:w-3 mx-auto my-4 rounded-full bg-white lg:bg-tertiary border border-white transition"
            />
            <span
              v-if="titles"
              class="block ml-3 lg:ml-0 lg:w-full lg:absolute lg:pin-x text-white"
              :class="[i % 2 === 0 ? 'lg:bottom-6' : 'lg:top-6']"
              v-html="stop.title"
            />
          </span>
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'TourStops',

  props: {
    titles: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters(['guidedtour'])
  }
}
</script>

<style scoped>
.router-link-exact-active .guided-stop > .guided-dot {
  /* background-color: #fff; */
  @apply bg-primary;
}

li:not(:last-of-type) a > .guided-stop:before {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateX(-50%);
  left: 0.25rem;
  height: 100%;
  width: 1px;
  background-color: #fff;
}

@screen lg {
  a:hover .guided-stop > .guided-dot,
  a:focus .guided-stop > .guided-dot {
    /* background-color: #fff; */
    @apply bg-secondary;
  }

  li:first-of-type a > .guided-stop:before {
    display: none;
  }

  li:not(:first-of-type) a > .guided-stop:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: calc(50% - 0.375rem);
    height: 1px;
    background-color: #fff;
  }

  li:not(:last-of-type) a > .guided-stop:after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    width: calc(50% - 0.375rem);
    height: 1px;
    background-color: #fff;
  }
}
</style>
